import React from 'react';
import { Key, CreditCard, Code, X } from 'lucide-react';
import './ItemTypeModal.css';

function ItemTypeModal({ isOpen, onClose, onSelectType }) {
  if (!isOpen) return null;

  const itemTypes = [
    {
      type: 'password',
      icon: Key,
      title: '패스워드',
      description: '웹사이트 로그인 정보',
      color: 'primary'
    },
    {
      type: 'creditcard',
      icon: CreditCard,
      title: '신용카드',
      description: '카드 정보 및 결제 수단',
      color: 'warning'
    },
    {
      type: 'apikey',
      icon: Code,
      title: 'API 키',
      description: 'API 키 및 라이선스',
      color: 'success'
    }
  ];

  const handleSelect = (type) => {
    onSelectType(type);
    onClose();
  };

  return (
    <>
      <div className="modal-backdrop" onClick={onClose} />
      <div className="item-type-modal">
        <div className="modal-header">
          <h2>새 항목 추가</h2>
          <button className="btn-close" onClick={onClose}>
            <X size={24} />
          </button>
        </div>
        
        <div className="modal-body">
          <p className="modal-description">
            추가하려는 항목 유형을 선택하세요
          </p>
          
          <div className="item-type-grid">
            {itemTypes.map(({ type, icon: Icon, title, description, color }) => (
              <button
                key={type}
                className={`item-type-option item-type-${color}`}
                onClick={() => handleSelect(type)}
              >
                <div className="option-icon">
                  <Icon size={32} />
                </div>
                <h3 className="option-title">{title}</h3>
                <p className="option-description">{description}</p>
              </button>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default ItemTypeModal;